<template>
      <div class="announcement announcement--demo">
        <router-link :to="{ name: 'logout', params: { _internal: true }, query: { next: 'web' }}" class="announcement__logo">
          <span class="announcement__icon"></span>
          <span class="announcement__app-name">Kiempunt</span>
        </router-link>
        <span class="announcement__inquiry">Kiempunt uitproberen in de klas? <a href="/proef/demo" class="button--inquiry button-timid button-forward ">Vraag gratis proefperiode aan</a></span>
      </div>
</template>


<script>
import PrimaryButton from 'js/components/elements/PrimaryButton.vue'

export default {
    props: {
        show: {
            type: Boolean,
            default: true,
        }
    },

    components: { PrimaryButton },

}
</script>


<style lang="scss">

    @import 'global';

    .announcement {
      background-color: $color-yellow;
      width: 100%;
      padding: 4px;
      z-index: $z-index-announcement;
      font-size: 0.9em;

      display: flex;
      align-items: center;

      &__inquiry {
        margin-left: auto;
      }

      .button--inquiry {
        font-weight: $font-body-bold-weight;
        border-radius: 4px;
        background-color: white;
        padding: 2px 2px 2px 10px;
        margin: 0 0 0 1em;
      }

      &__logo {
        margin: 0 0 0 0.5em;
        padding: 0;
        &:hover {
          .announcement__icon {
            @include background-sprite-replace($icon-logo-dark-group);
            display: inline-block;
          }
        }
      }

      &__icon {
        @include background-sprite-replace($icon-logo-primary-group);
        display: inline-block;
      }

      &__app-name {
        font-family: $font-heading;
        margin-left: 0.3em;
        font-size: 1.2em;

        display: inline-block;
        vertical-align: 2px;
        margin-top: -3px;
      }

    }

    @media print {
      .announcement {
        display: none;
      }
    }

</style>



// WEBPACK FOOTER //
// DemoMessage.vue?1988389b